export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mugs.97b7c4c.svg";